import z from 'zod';

export const orderingSchema = z
  .object({
    column: z.string(),
    asc: z.boolean(),
  })
  .nullable()
  .default(null);

export type Ordering = z.infer<typeof orderingSchema>;

export const tableStateSchema = z.object({
  filters: z.object({}).default({}),
  ordering: orderingSchema,
  sizing: z.record(z.number()).default({}),
  visibility: z.record(z.boolean()).default({}),
  columnOrder: z.array(z.string()).default([]),
  columnPinning: z
    .object({
      left: z.array(z.string()).default([]),
      right: z.array(z.string()).default([]),
    })
    .default({
      left: [],
      right: [],
    }),
});

export type TableState = z.infer<typeof tableStateSchema>;
